import React from "react";
import { connect } from "react-redux";
import { saveUser } from "../../reducers/user/actions";
import { navigate } from "../../services";
import { Form } from "../../lib";
import { Constraints, Fields } from "./types";
import { AppState } from "../../store";

const mapStateToProps = (state: AppState) => ({ user: state.user });
const mapDispatchToProps = { saveUser };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type Props = StateProps & DispatchProps;

class EditProfileForm extends React.Component<Props> {
    private order = ["name", "email", "password", "confirmPassword"];

    private fields: Fields = {
        name: {
            type: "text",
        },
        email: {
            type: "email",
        },
        password: {
            type: "password",
        },
        confirmPassword: {
            type: "password",
        },
    };

    private constraints: Constraints = {
        name: {
            presence: { message: "nameRequired" },
            length: {
                minimum: 3,
                message: "nameMinChars",
            },
        },

        email: {
            presence: { message: "emailRequired" },
            email: { message: "emailInvalid" },
        },

        password: {
            presence: { message: "passwordRequired" },
        },

        confirmPassword: function (
            value,
            attrs,
            _attrName,
            _options,
            _constraints
        ) {
            if (attrs.password.length === 0) {
                return {};
            }

            if (attrs.password.length > 0 && attrs.password.length < 6) {
                return {
                    presence: { message: "passwordRequired" },
                    length: {
                        minimum: 6,
                        message: "passwordMinChars",
                    },
                };
            }

            if (attrs.password !== value) {
                return {
                    presence: { message: "confirmPasswordRequired" },
                    equality: {
                        attribute: "password",
                        message: "confirmPasswordSameAsPassword",
                    },
                };
            }
        },
    };

    onSubmit = (values: Record<string, any>) => this.props.saveUser(values);

    onCancel = () => navigate.to("/app/docs");

    render() {
        return (
            <Form
                id="editProfile"
                heading="title"
                updateProp="user"
                user={this.props.user}
                order={this.order}
                fields={this.fields}
                constraints={this.constraints}
                focusOnFirst={true}
                onSubmit={this.onSubmit}
                onAlternate={this.onCancel}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditProfileForm);
